import { Column, Row, Text } from "@/components";
import { DashboardUserSelector } from "@/components/dashboard/DashboardUserSelector";

import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import {
  DASHBOARD_HEADER_HEIGHT_PX,
  DASHBOARD_HEADER_MINIMIZED_HEIGHT_PX,
} from "@/lib/constants";
import { dates } from "@/lib/dates";
import { cn } from "@/lib/utils";
import { DashboardSelectedUser } from "@/types";

const SELECTOR_TRIGGER_CLASS =
  "h-lever-8 w-auto shrink-0 rounded-lever-md border-lever-border-action bg-lever-surface-default px-lever-3 font-lever-suisse text-xs font-normal text-lever-text-body hover:bg-lever-surface-neutral";

export const DashboardHeader = ({
  isMinimized,
  selectedUserId,
  onSelectedUserIdChange,
}: {
  isMinimized: boolean;
  selectedUserId: DashboardSelectedUser;
  onSelectedUserIdChange: (value: DashboardSelectedUser) => void;
}) => {
  /* Database CRUD Operations */
  // Read
  const currentUser = useGetCurrentUser();

  /* Helpers */
  const today = new Date();
  const weekday = today.toLocaleDateString("en-US", { weekday: "long" });
  const fullDate = dates.formatLongDate(today);

  /* Render */
  const render = () => (
    <Column
      className={cn(
        "dashboard-editorial-header relative mx-6 shrink-0 justify-between",
        isMinimized && "dashboard-editorial-header-compact",
      )}
      style={{
        minHeight: isMinimized
          ? DASHBOARD_HEADER_MINIMIZED_HEIGHT_PX
          : DASHBOARD_HEADER_HEIGHT_PX,
      }}
    >
      <Row className="relative z-10 min-w-0 items-start justify-between gap-lever-4">
        <Column className="min-w-0 gap-lever-1">
          <Text className="font-lever-accent text-[length:var(--lever-font-size-3)] font-normal uppercase tracking-widest text-lever-text-label">
            {fullDate}
          </Text>
          <Text className="dashboard-editorial-title mb-lever-1 text-lever-text-heading">
            Happy {weekday}, {currentUser?.firstName}.
          </Text>
          {!isMinimized ? (
            <Text className="font-lever-suisse text-sm font-normal text-lever-text-footnote">
              Here&apos;s how your team is performing today.
            </Text>
          ) : null}
        </Column>
        <DashboardUserSelector
          onValueChange={onSelectedUserIdChange}
          triggerClassName={SELECTOR_TRIGGER_CLASS}
          value={selectedUserId}
        />
      </Row>
    </Column>
  );

  return render();
};
